import { get, postJSON, del, post } from '../utils/axios'

// 车辆管理头部数据统计
export const carListStatistics = (options) => postJSON('car/carListStatistics', options)

// 车辆管理列表
export const findUserInfoList = (options) => postJSON('car/findUserInfoList',options)

// 车辆群组统计
export const carGroupStatistics = (options) => postJSON('car/carGroupStatistics', options)

// 删除车辆群组
export const deleteCarGroup = (options) => del('group/deleteCarGroup',options)

// 车辆标签统计
export const carLabelStatistics = (options) => postJSON('car/carLabelStatistics', options)

// 消费类型统计
export const consumeTypeStatisticsCarNumber = (options) => postJSON('car/consumeTypeStatisticsCarNumber', options)

// 车辆价格统计
export const carPriceStatistic = (options) => postJSON('car/carPriceStatistic', options)

// 行驶里程统计
export const carMileageStatistic = (options) => postJSON('car/carMileageStatistic', options)

// 行驶年限统计
export const carFirstRegTimeStatistic = (options) => postJSON('car/carFirstRegTimeStatistic', options)

// 按品牌统计
export const carBrandStatistics = () => get('car/carBrandStatistics')

// 保存车辆信息
export const saveCarInfo = (options) => postJSON('car/saveCarInfo',options)

// 按车牌查询车辆信息
export const selectCarInfoByCarNo = (options) => get('car/selectCarInfoByCarNo',options, null, false)

// 完工查看
export const constructionFinishQuery = (options) => get('constructionBill/constructionFinishQuery',options)

// 服务流程查询
export const constructionProcess = (options) => get('constructionBill/constructionProcess',options)

// VIN查询车型
export const getCarTypeBaseInfoByVinCode = (options) => get('carType/getCarTypeBaseInfoByVinCode',options)

// 根据VIN码查询车辆+客户基本信息
export const getCarInfoByVinCode = (options) => post('car/getCarInfoByVinCode',options, {}, false)

// 车辆绑定解绑
interface UpdateCarBindStatusOptions {
    orgPk?: string // 门店pk，公众号需要传，不传后台默认根据token取
    carPk: string // 车牌PK
    status: string // 状态0-解绑 1-绑定
    userPk: string // 客户pk
}
export const updateCarBindStatus = (options: UpdateCarBindStatusOptions) => post('car/updateUserBindStatus', options)









